import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";

export const positionerStyle = style({
  zIndex: 1000,
});

export const tooltipStyle = recipe({
  base: {
    pointerEvents: "none",
    width: "max-content",
    maxWidth: rem(280),
  },
  variants: {
    variant: {
      default: {
        backgroundColor: theme.colors.onBackground,
        color: theme.colors.background,
      },
      error: {
        backgroundColor: theme.colors.error,
        color: theme.colors.onError,
      },
    },
    size: {
      m: {
        borderRadius: theme.borderRadiuses.s,
        padding: `calc(${theme.spacings.s} - ${theme.spacings.xxs}) ${theme.spacings.s}`,
      },
    },
  },
  defaultVariants: {
    variant: "default",
    size: "m",
  },
});
